import {udemyCoursesSection} from "../../portfolio";
import React, {useContext} from "react";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import Button from "../../components/button/Button";

export default function UdemyCourses() {
  const {isDark} = useContext(StyleContext);
  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="udemyCourses">
        <div>
          <h1 className="skills-heading">{udemyCoursesSection.title}</h1>
          <p
            className={
              isDark
                ? "dark-mode project-subtitle"
                : "subTitle project-subtitle"
            }
          >
            {udemyCoursesSection.subtitle}
          </p>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "1rem"
            }}
          >
            {udemyCoursesSection.courses.map((course, i) => {
              return (
                <div
                  key={i}
                  style={{
                    flex: "1 1 calc(33.33% - 2rem)", // 3 in a row with margins
                    maxWidth: "350px",
                    borderRadius: "12px",
                    overflow: "hidden",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                    margin: "1rem",
                    fontFamily: "sans-serif"
                  }}
                >
                  <a
                    href={course.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{textDecoration: "none", color: "inherit"}}
                  >
                    <img
                      src={course.image}
                      alt={course.title}
                      style={{width: "100%", height: "auto"}}
                    />
                    <div style={{padding: "1rem"}}>
                      <h3 style={{margin: "0 0 0.5rem 0", fontSize: "1.1rem"}}>
                        {course.title}
                      </h3>
                      <p style={{fontSize: "0.9rem", color: "#555"}}>
                        {course.description}
                      </p>
                      <Button text="View Course on Udemy"></Button>
                    </div>
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Fade>
  );
}
